import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Type } from 'projects/c1-backend/src/app/db/type';
import { TypesService } from 'projects/c1-backend/src/app/services/types.service';
import { ModelList } from 'projects/core/src/include/modellist';
import { Filter, FilterMode } from 'projects/core/src/include/structures';
import { Dossier, DossierField, FilterDossier } from '../../dossier';
import { DossierService } from '../../services/dossier.service';
import { DossierPhasesService } from '../../services/dossierphases.service';
import { DetailComponent } from './detail/detail.component';
import { Globals } from 'projects/core/src/globals';
import { PreviewComponent } from './preview/preview.component';
import { DossierOverviewsService } from '../../services/dossieroverviews.service';
import { apply } from 'mathjs';
import { NotificationService } from 'projects/core/src/lib/notification.service';
import { formatDate } from '@angular/common';
import { ToastMode } from 'projects/core/src/include/structures';
import { NotesService } from 'projects/c1-backend/src/app/services/notes.service';
import { UserService } from 'projects/core/src/lib/user.service';

@Component({
  selector: 'app-dossierlist',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css']
})
export class ListComponent extends ModelList<Dossier> implements OnInit {
  
  override modulename="dossier";
  
  tab=1;  
  filterTmp="";
  filterFieldValues=[];
  fields:DossierField[]=[];
  overviews=[];

  @Input()
  id_type:number=0;  

  get showHeaderTable(){
    if(this.module)
      return this.module.getParam("show_default_header_table",true);
    else
      return true;
  }

  get cols(){
    if(this.module)
      return this.module.getParam("cols_overview",3);
    else
      return 3;
  }

  constructor(
    private fb1: UntypedFormBuilder,
    private dossierService: DossierService,
    private dossierphasesService: DossierPhasesService,
    private dossierOverviewsService:DossierOverviewsService,
    private notificationService:NotificationService,
    private notesService:NotesService,
    private userService:UserService

  ) { 
    super(dossierService,fb1);
    this.detailViewModal=DetailComponent; 
    
  }


  filter_search:Filter=new Filter();
  filter_status:Filter=new Filter();
  filter_id_type:Filter<number>=new Filter();
  filter_id_user:Filter<number>=new Filter();
  filter_fieldvalue:Filter=new Filter();
  filter_fieldsearchable:Filter=new Filter();
  filter_advanced:Filter=new Filter();
  
  filters_advanced:FilterDossier[]=[];

  filter_toRead:Filter<number>=new Filter();

  users:any=[];

  /** 
   * Mostra solo le pratiche assegnate all'utente loggato
   */
  showRecordsOnlyUser=false;

  ngOnInit(): void {

    this.title = 'Pratiche';
    super.ngOnInit.apply(this);

    this.showRecordsOnlyUser = this.checkPermissions("showRecordsOnlyUser");

    this.userService.getUsers().subscribe((result)=>{
      this.users=result;
    });
  
    this.tab=this.module.getParam("default_dashboard_view","overview")=="overview"?1:2;

    this.filter_search.mode=FilterMode.like;
    this.filter_search.fields=[];
    this.filter_search.fields.push("d.title");
    this.filter_search.fields.push("d.code");
    this.filter_search.fields.push("dfv.value");

    this.filter_search.value="";
    this.filter.push(this.filter_search);

    this.filter_fieldsearchable.mode=FilterMode.normal;
    this.filter_fieldsearchable.fields=[];
    this.filter_fieldsearchable.fields.push("df.searchable");
    this.filter_fieldsearchable.value="1";
   // this.filter.push(this.filter_fieldsearchable);

    this.filter_id_type.mode=FilterMode.like;
    this.filter_id_type.fields=[];
    this.filter_id_type.fields.push("d.id_type");
    this.filter_id_type.value=this.id_type;
    this.filter.push(this.filter_id_type);

    this.filter_id_user.mode=FilterMode.normal;
    this.filter_id_user.fields=[];
    this.filter_id_user.fields.push("d.id_user");
    this.filter_id_user.fields.push("du.id_user");
    if(this.showRecordsOnlyUser){
      this.filter_id_user.value=Globals.user.id;
    }else{
      this.filter_id_user.value=0;
    }
    this.filter_id_user.nullvalue=0;
    this.filter.push(this.filter_id_user);

    this.filter_status.mode=FilterMode.normal;
    this.filter_status.fields=[];
    this.filter_status.fields.push("d.status");
    this.filter_status.value="1";
    this.filter.push(this.filter_status);
    
    this.filter_fieldvalue.mode=FilterMode.custom;
    this.filter_fieldvalue.fields=[];
    this.filter_fieldvalue.value="";
    this.filter.push(this.filter_fieldvalue);

    this.filter_toRead.mode=FilterMode.normal;
    this.filter_toRead.enabled=false;
    this.filter_toRead.fields=[];
    this.filter_toRead.value=0;

    this.filter_advanced.mode=FilterMode.custom;
    this.filter_advanced.enabled=false;
    this.filter_advanced.fields=[];
    this.filter_advanced.value="";
    this.filter.push(this.filter_advanced);
    
    this.beforeGetItems=()=>{
        this.other_params=[this.id_type];

        // console.log(this.filters_advanced);
        if(this.filters_advanced.length>0){
          let sql=[];
          for(let f of this.filters_advanced){
            if(f.value!=""){
              
              switch (f.condition){
                case "ugual":
                  sql.push("__dossierfields.`"+f.field.name+"` = \""+f.value+"\"");
                  break;
                case "minor":
                  sql.push("__dossierfields.`"+f.field.name+"` < \""+f.value+"\"");
                  break;
                case "major":
                  sql.push("__dossierfields.`"+f.field.name+"` > \""+f.value+"\"");
                  break;
                case "minorugual":
                  sql.push("__dossierfields.`"+f.field.name+"` <= \""+f.value+"\"");
                  break;
                case "majorugual":
                  sql.push("__dossierfields.`"+f.field.name+"` >= \""+f.value+"\"");
                  break;
                case "like":
                  sql.push("__dossierfields.`"+f.field.name+"` LIKE \"%"+f.value+"%\"");
                  break;
                case "notlike":
                  sql.push("__dossierfields.`"+f.field.name+"` NOT LIKE \"%"+f.value+"%\"");
                  break;
                case "null":
                  sql.push("__dossierfields.`"+f.field.name+"`= \"\" OR __dossierfields.`"+f.field.name+"` IS NULL");
                  break;
                case "notnull":
                  sql.push("__dossierfields.`"+f.field.name+"`!= \"\" AND __dossierfields.`"+f.field.name+"` IS NOT NULL");
                  break;
              }
              
              
            }
          }

          this.filter_advanced.enabled=true;
          this.filter_advanced.value=sql.join(" AND ");
          
        }else{
           this.filter_advanced.enabled=false;
        }

        this.aux_parameter=this.filter_toRead.value>0?[this.filter_toRead.value]:"";
   
    }


    this.afterGetItems=()=>{
      /*for(let i=0;i<this.list.length;i++){
        
        try{
          this.list[i]['users']=JSON.parse(this.list[i].users);
        }catch{
          this.list[i]['users']=[];
        }
      }*/

      this.getOverviews();
    }
   

  }


  ngOnChanges(){
    if(this.id_type>0){
      this.dossierphasesService.getFieldsToShow(this.id_type).subscribe((items)=>{
        this.fields=items;
        this.getItems();
      });
    }
  }


  getParams(text){

    if(Array.isArray(text)){
      return text;
    }else{
      return JSON.parse(text);
    }
  }


  setFilterFieldValue(field,value){

    //trova il filtro
    let found=false;
    for(let f of this.filterFieldValues){
      if(f.field==field){
        f.value=value;
        found=true;
      }
    }

    if(!found){
      let f:any={};
      f.field=field;
      f.value=value;
      this.filterFieldValues.push(f);
    }

    let sql=[];
    for(let f of this.filterFieldValues){
      if(f.value!="")
        sql.push("__dossierfields.`"+f.field.name+"`=\""+f.value+"\"");
        //sql.push("dfv.id_field="+f.field.id+" AND dfv.value=\""+f.value+"\"")
    }

    if(sql.length>0){
      this.filter_fieldvalue.value=sql.join(" AND ");
    }else{
      this.filter_fieldvalue.value="";
    }
    
    this.getItems();
   
  }


  openPreview(record){
    Globals.modal.showModal(PreviewComponent,[
      {"name":"record","value":record}
    ],()=>{

    });
  }


  getOverviews(){
    console.log("Dossier type: ",this.filter_id_type.value);
    this.dossierOverviewsService.getOverviews(this.filter_id_type.value).subscribe((result)=>{
      this.overviews=result;
    })
  }


  getKeys(obj){
    if(obj)
      return Object.keys(obj);
    else
      return [];
  }


  notify(record:Dossier){  
    this.notificationService.showPreviewNotification(record.addressItem.contacts,record,"dossier",()=>{

    });      
  }

  getTitle(phase){
    switch(phase.state){
      case 1:
        return phase.title+" (in corso)";
      case 2:
        return phase.title+" (completata)";
      case 3:
        return phase.title+" (annullata)";   
      case 4:
        return phase.title+" (verificata)";   
      case 5:
        return phase.title+" (in attesa)";   
      case 6:
        return phase.title+" (archiviata)";   
      default:
        return phase.title+" (da avviare)";   
    }
  }


  getLastLog(record){
    if(record.log){
      if(record.log.length>0){
        return record.log[record.log.length-1];
      }
    }

    return null;

  }


  listNotes(notes){
    // raccoglie le note per il tooltip
    let result='';
    for(let n of notes){
      if(n.state==1){
        result = result + formatDate(n.date,'dd-MM-yyyy',"it-IT") + ' | ' + n.value + '\n';
      }        
    }
    if (result!='') result = result + '(Doppio Click per segnare come letto)';
    return result;

  }

  markNotes(notes){
    // segna tutte le note come lette
    for(let n of notes){
      n.state=2;
    }

    this.notesService.saveMultiple(notes,()=>{
      Globals.message.showToaster("Tutte le note sono state segnate come lette",ToastMode.INFO);
      this.getItems();
    });
  }

   parseJSON(value: string,defaultvalue=[]){
    try{
      return JSON.parse(value);
    }catch{
      return defaultvalue;
    }
  }


  dossierIsRead(record:Dossier){
    if(record.users){
      for(let u of record.users){
        if(u.id_user==Globals.user.id){
          if(u.read==1)
            return true;
          else
            return false;
        }
      }
    }

    return false;
  }

} 
